import _ from "lodash";
import * as ActionType from "../../actions/actionType";

const initialState = {
  data: {},
  loading: false,
  fetched: false,
  recentlyView: [],
  recentlyViewMax: 5
};

const handleRecentlyProductToLocalStorage = (id, recentlyViewMax) => {
  let recentlyProduct = window.localStorage.getItem("recentlyProduct") || [];
  if (!_.isEmpty(recentlyProduct)) {
    recentlyProduct = JSON.parse(recentlyProduct);
  }
  const firstRecentlyProducts = recentlyProduct[0];
  if (!_.isEqual(firstRecentlyProducts, id)) {
    recentlyProduct.unshift(id);
  }
  if (_.size(recentlyProduct) > recentlyViewMax) {
    recentlyProduct.pop();
  }
  window.localStorage.setItem("recentlyProduct", JSON.stringify(recentlyProduct));
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCHING_PRODUCTS:
      return {
        ...state,
        loading: true,
        fetched: false
      };
    case ActionType.RECEIVE_PRODUCTS:
      return {
        ...state,
        data: action.data,
        loading: false,
        fetched: true
      };
    case ActionType.RECEIVE_PRODUCTS_RECENTLY_VIEW:
      return {
        ...state,
        recentlyView: action.data
      };
    case ActionType.ADD_PRODUCTS_RECENTLY_VIEW:
      const { recentlyView, recentlyViewMax } = state;
      handleRecentlyProductToLocalStorage(action.id, recentlyViewMax);
      const firstRecentlyProducts = recentlyView[0];
      if (!_.isEqual(firstRecentlyProducts, action.id)) {
        recentlyView.unshift(action.id);
      }
      if (_.size(recentlyView) > recentlyViewMax) {
        recentlyView.pop();
      }
      return {
        ...state,
        recentlyView
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/product/products.js